import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 100,
	fill: "none",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#9B7447",
			d: "M61.88.96C54.4 9.1 65.75 19.84 72.48 18.7c.28-.05.49.26.27.46-2.3 2.2-8.64 6.16-7.61 11.62 1.09 5.85 8.66 1.45 11.95-1.61a.32.32 0 0 1 .52.15c1.53 6.13 6.54 14.53 12.86 12.84 4.76-1.27 3.12-8.45 1.36-12.78a.65.65 0 0 1 .74-.87c9.96 2.16 12.99-1.6 13.25-3.84 1.2-4.87-8.43-9.2-13.86-10.92a.32.32 0 0 1-.12-.53c2.33-2.24 5.44-6.9 1.7-10.33-3.61-3.32-9.44 2.38-12.27 5.98-.2.25-.65.07-.65-.24C80.56.56 69.32-7.17 61.88.96Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 81.05,
			cy: 18.02,
			r: 1.55,
			fill: "#BA1B0D",
			transform: "rotate(-47 81.05 18.02)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 84.86,
			cy: 21.52,
			r: 1.55,
			fill: "#BA1B0D",
			transform: "rotate(-47 84.86 21.52)"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			d: "M71.81 11.35c1.24.43 3.62-.53 2.45-2.67"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 67.82,
			cy: 8.75,
			r: 1.03,
			fill: "#fff",
			transform: "rotate(-16 67.82 8.75)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 70.91,
			cy: 4.61,
			r: 1.03,
			fill: "#fff",
			transform: "rotate(-16 70.9 4.6)"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_12129_30092",
			width: 46,
			height: 45,
			x: 60,
			y: -2,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#382A1A",
				fillOpacity: .97,
				d: "M62.5 1.73c-7.66 8.36 4.53 14.42 10.5 16.6.2.07.26.3.13.44-1.88 2.11-9.09 6.2-8 12.01 1.1 5.85 8.66 1.46 11.96-1.61a.32.32 0 0 1 .52.15c1.53 6.13 6.53 14.54 12.85 12.84 4.76-1.27 3.12-8.45 1.37-12.78a.65.65 0 0 1 .73-.87c9.96 2.16 13-1.6 13.25-3.84 1.2-4.87-8.43-9.2-13.86-10.92a.32.32 0 0 1-.12-.53c2.34-2.24 5.44-6.9 1.7-10.33-3.8-3.5-10.06 3.04-12.69 6.58a.3.3 0 0 1-.52-.05C77.56 3.68 70.12-6.57 62.5 1.73Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_12129_30092)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#715739",
				fillOpacity: .47,
				d: "M95.55 38.83c-18.47 4.59-4.76-9.68-30.07-16.55-12.96 20 4.9 20.38 15.53 28.38 10.4-6.12 33.02-16.42 14.54-11.83Z"
			})
		})
	]
});
const SvgTileBgGingerbread = styled(base)({});
export default SvgTileBgGingerbread;
